// extracted by mini-css-extract-plugin
export default {"searchBox":"SearchBox_searchBox__XzT5Z","endAdornment":"SearchBox_endAdornment__9XZyn","menuItem":"SearchBox_menuItem__Uatl8"};